<template>
  <layout-main-inner title="检后监管">
    <layout-card-wrap :hasHeaderSlot="userPermission.SUPERVISE || userPermission.ENT"
                      v-loading="loading">
      <template slot="form">
        <assign-ent-select v-if="userPermission.SUPERVISE"
                           immediate
                           v-model="config.vendorId"
                           style="margin-right: 10px"
                           :option="{}"
                           :callback="() => {handleCurrentChange(1)}" />
        <el-input placeholder="请输入标签序号"
                  v-model="config.tagNo"
                  style="width: 150px;margin-right: 10px;">
        </el-input>
        <el-input placeholder="请输入商品识别码"
                  v-model="config.eic"
                  style="width: 150px;margin-right: 10px;">
        </el-input>
        <el-input placeholder="请输入报关单号"
                  v-model="config.declarationCode"
                  style="width: 180px;">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
                stripe
                :data="list">
        <el-table-column label="商品名称"
                         min-width="200"
                         fixed="left">
          <template slot-scope="{row}">
            {{row.productName}}<span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
          </template>
        </el-table-column>
        <el-table-column label="企业名称"
                         min-width="160"
                         v-if="userPermission.SUPERVISE"
                         prop="vendorName">
        </el-table-column>
        <el-table-column label="现场照片"
                         min-width="280">
          <template slot-scope="{row}">
            <image-list :fileList="row.envImage" />
          </template>
        </el-table-column>
        <el-table-column label="定位信息"
                         prop="address"
                         width="200">
        </el-table-column>
        <el-table-column label="备注"
                         prop="remark"
                         width="120">
        </el-table-column>
        <el-table-column label="标签序号"
                         width="100"
                         prop="formatedTagNo">
        </el-table-column>
        <el-table-column label="商品识别码"
                         width="180"
                         prop="eic">
        </el-table-column>
        <el-table-column label="报关单号"
                         width="150"
                         prop="declarationCode">
        </el-table-column>
        <el-table-column label="批次号"
                         width="120"
                         prop="batchCode">
        </el-table-column>
        <el-table-column label="上传时间"
                         fixed="right"
                         width="140">
          <template slot-scope="{row}"> {{ row.createdTime | dateformat()}} </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
import ImageList from '@/components/public/image-list.vue'
export default {
  name: 'supervise-list',
  components: { AssignEntSelect, ImageList },
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, productName: '', status: 2, vendorId: null, tagNo: null, eic: null, declarationCode: null },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList (batchId = null) {
      this.loading = true
      this.$store.dispatch('supervise/getsupervisions', {
        payload: { ...this.config, batchId },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.envImage = item.productPhoto ? item.productPhoto.split(',').map(o => ({ url: o })) : []
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.fetchList(this.$route.params.batchId)
  }
}
</script>
